export default __webpack_public_path__ + "images/deff2ecf96237ebb941ddc8b37e4fb4e.png";